<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="mb-4" :class="alturaCard">
          <v-card-title primary-title>
            <v-layout row>
              <v-flex xs12 style="display: flex" v-show="dados.length > 0">
                <h3 class="headline mb-0">
                  {{ titulo }}
                </h3>
                <v-spacer></v-spacer>
                <v-btn
                  depressed
                  class="mr-0 hidden-xs-only no-print"
                  @click="abrirDetalhamento"
                  v-show="dados.length > 0"
                >
                  <v-icon class="mr-2">list_alt</v-icon>DETALHES
                </v-btn>
                <v-btn
                  depressed
                  class="mr-0 hidden-sm-and-up no-print"
                  @click="abrirDetalhamento"
                  v-show="dados.length > 0"
                >
                  <v-icon>list_alt</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <pie-chart-produtos-mais-vendidos :dados="dados" />
                <sem-informacoes v-if="dados.length == 0" />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <div v-if="observacoes" style="text-align: right; width: 100%">
                  {{ observacoes }}
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <as-dialogo ref="dialogoDetalhes" :title="titulo" max-width="680px">
      <v-layout>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="lista"
            class="elevation-1"
            :items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:item.Legenda="{ item }">
              {{ item.Legenda }}
            </template>
            <template v-slot:item.Quantidade="{ item }">
              {{ valorBR(item.Quantidade, 0) }}
            </template>
            <template v-slot:item.Valor="{ item }">
              {{ item.Valor | valorBR }}
            </template>

            <template v-slot:body.append v-if="lista.length > 0">
              <tr>
                <td style="text-align: end">
                  <v-label>Total</v-label>
                </td>
                <td style="text-align: center">
                  <h3>{{ valorBR(totalQuantidade, 0) }}</h3>
                </td>
                <td style="text-align: right">
                  <h3>{{ totalValor | valorBR }}</h3>
                </td>
              </tr>
            </template>
          </v-data-table>
          <br />
          <div v-if="observacoes" style="text-align: right; width: 100%">
            {{ observacoes }}
          </div>
        </v-flex>
      </v-layout>
    </as-dialogo>
  </div>
</template>

<script>
import PieChartProdutosMaisVendidos from "./PieChartProdutosMaisVendidos.vue";
import SemInformacoes from "./SemInformacoes.vue";

export default {
  name: "GraficoProdutosMaisVendidos",
  components: {
    PieChartProdutosMaisVendidos,
    SemInformacoes,
  },
  props: {
    dados: {
      type: Array,
    },
    lista: {
      type: Array,
    },
    totalQuantidade: {
      type: Number,
      default: 0,
    },
    totalValor: {
      type: Number,
      default: 0,
    },
    titulo: {
      type: String,
      default: "",
    },
    observacoes: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      headers: [
        { text: "Legenda", sortable: false, value: "Legenda", width: "80%" },
        {
          text: "Quantidade",
          sortable: false,
          value: "Quantidade",
          width: "10%",
          align: "center",
        },
        {
          text: "Valor",
          sortable: false,
          value: "Valor",
          width: "10%",
          align: "right",
        },
      ],
      alturaSemInformacoes: {
        height: "140px !important",
      },
      alturaCard: {
        minHeight: "500px",
      },
    };
  },
  methods: {
    abrirDetalhamento() {
      this.$refs.dialogoDetalhes.abrir();
    },
  },
  computed: {
    mostrarAltura() {
      return (this.alturaCard =
        this.dados.length == 0 ? this.alturaSemInformacoes : this.alturaCard);
    },
  },
};
</script>

<style scoped>
/*  */
</style>
